import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { FAQS, buildWhatsAppLink } from "../../lib/constants";
import { MessageCircle } from "lucide-react";

export const FAQSection = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="bg-white py-20 md:py-28"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20">
                    <div className="lg:sticky lg:top-28 lg:self-start">
                        <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                            · Perguntas frequentes ·
                        </span>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight text-black mt-3 leading-[0.95]">
                            Tudo que você precisa saber{" "}
                            <span className="text-[#f45100]">
                                antes de chamar.
                            </span>
                        </h2>
                        <p className="mt-5 text-gray-600 text-base md:text-lg">
                            Não encontrou sua dúvida? Mande uma mensagem rápida
                            no WhatsApp — respondemos em segundos, 24h por dia.
                        </p>
                        <a
                            href={buildWhatsAppLink(
                                "Olá! Tenho uma dúvida sobre o serviço de guincho.",
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="faq-whatsapp-btn"
                            className="mt-7 inline-flex items-center gap-2 px-6 py-4 bg-[#0a0a0a] hover:bg-[#f45100] text-white rounded-xl font-bold text-sm uppercase tracking-wider transition-all hover:scale-[1.02]"
                        >
                            <MessageCircle size={16} strokeWidth={2.5} />
                            Tirar dúvida no WhatsApp
                        </a>
                    </div>

                    <div>
                        <Accordion
                            type="single"
                            collapsible
                            className="w-full space-y-3"
                        >
                            {FAQS.map((faq, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border border-gray-200 hover:border-[#f45100] transition-colors px-5 md:px-6 rounded-none"
                                >
                                    <AccordionTrigger className="font-display text-left text-base md:text-lg font-extrabold uppercase tracking-tight text-black hover:no-underline py-5">
                                        {faq.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-gray-600 text-[15px] leading-relaxed pb-5">
                                        {faq.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};
